import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http'
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptService implements HttpInterceptor {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token: any = this.sessionService.getToken();

    if (token) {
      request = request.clone({
        headers: request.headers
          .set('Authorization', `Bearer ${token}`)
      });
    }

    return next.handle(request)
      .pipe(
        tap({
          next: (event) => {
            if (event instanceof HttpResponse) {
              ;
            }
          },
          error: (error) => {
            if (error instanceof HttpErrorResponse) {
              switch (error.status) {
                case 401: // Unauthorized
                  this.sessionService.clearSessionData();
                  if (globalThis.location?.pathname !== '/') {
                    globalThis.location.href = '/';
                  }
                  break;
                case 404: // Not Found
                  this.router.navigateByUrl('/404');
                  break;
                case 0: // Likely network errors or CORS issues
                  console.error('Server down or CORS error:', error.message);
                  break;
                // Handle other status codes as needed
                default:
                  console.error('HTTP Error:', error.message);
              }
            }
          }
        })
      )
  }
}
